module.exports = __webpack_public_path__ + "img/choose-action-bar-1.350d3cde.png";